// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
export enum LoadingBehavior {
  Normal = 'normal',
  Bypass = 'bypass'
}
